import Logoblu from '../logo_blu.png';

export const openMASWReport = ({name,tipo,comm,loc,add,parMV,parMH,parFP,parVFAS,parTRACE,parpsub,parVS,parinterval,parspettro}) => {
      const parFPArray = Array.isArray(parFP) ? parFP : [parFP];
      const parVFASArray = Array.isArray(parVFAS) ? parVFAS : [parVFAS];
      // Costruisci un array di oggetti "combinati" per ogni frequenza
      const combinedData = parFPArray.map((fpick, index) => ({
          fpick: fpick,
          spick: parVFASArray[index], // sicuro che esista almeno un elemento
        }));
      // Genera array separati (utile per grafici o tabelle)
      const fpick = combinedData.map(d => d.fpick);
      const spick = combinedData.map(d => d.spick);

      // Valori generali (1 solo valore)
      const tipologiaVal = tipo;
      const nomeProvaVal = name;
      const committenteVal = comm;
      const luogoVal = loc;
      const indirizzoVal = add;
      // Parametri aggiuntivi (array corti)
      const parMVVal = parMV;
      const parMHVal = parMH;
      const tracceVal = parTRACE;
      const spettroImg = parspettro;
      // Parametri singoli
      const parpsubVal = parpsub;
      const parVSVal = parVS;
      const parint = parinterval;

      const trcVal = Array.isArray(parTRACE)? parTRACE: [parTRACE];
      const trcLen= trcVal.length

  // Data e ora odierna
  const now = new Date();
  const dateStr = now.toLocaleDateString('it-IT');
  const timeStr = now.toLocaleTimeString('it-IT');

  // Apriamo una nuova finestra per il report
  const reportWindow = window.open('', '_blank', 'width=1200,height=750');


  reportWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <script src="https://cdn.plot.ly/plotly-2.27.1.min.js"></script>
        <style>
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background: white;
          }

          /* Pulsanti a destra */
          .controls {
            position: fixed;
            top: 10px;
            right: 10px;
            z-index: 1000;
            display: flex;
            gap: 5px;
            background: rgba(255,255,255,0.9);
            padding: 5px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          .print-btn {
            background: #12455b;
            color: white;
            border: none;
            width: 32px;
            height: 32px;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .print-btn:hover {
            background: #0d3445;
          }

          /* PAGINE - senza salti automatici */
          @page {
            size: A4;
            margin: 1.5cm;
          }

          /* Pagina 1 - Verticale */
          .page1 {
            page: A4;
            min-height: 100vh;
            position: relative;
            padding: 20px;
          }

          /* Pagina 2 - Orizzontale */
          .page2 {
              page: landscape;
              size: A4 landscape;
              position: relative;
              padding: 5px 0px;
              display: flex;
              flex-direction: column;

              width: 100%;
              box-sizing: border-box; /* evita che il padding allarghi il box */
            }

          .content-wrapper {
              display: flex;
              flex-direction: column;
              flex: 1;
            }

          @page landscape {
            size: A4 landscape;
            margin: 1.5cm;
          }

          /* Logo solo prima pagina */
          .logo {
            position: absolute;
            bottom: 20px;
            right: 20px;
            width: 33px;
            height: auto;
            opacity: 0.7;
          }

          .logo img {
            width: 100%;
            height: auto;
            display: block;
          }

          /* Pagina 1 - Stili */
          .header {
            text-align: center;
            margin-bottom: 20px;
          }

          .header h1 {
            font-size: 28px;
            color: #333;
            margin-bottom: 5px;
          }

          .header h2 {
            font-size: 20px;
            color: #666;
            font-weight: normal;
          }

          .delimiter {
            text-align: right;
            font-size: 12px;
            color: #666;
            margin-bottom: 20px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
          }

          .data-table {
            width: 100%;
            border-collapse: collapse;
          }

          .data-table td {
            padding: 8px 12px;
            border: 1px solid #ddd;
          }

          .data-table td:first-child {
            font-weight: bold;
            background-color: #f5f5f5;
            width: 150px;
          }

          .data-table input {
            width: 100%;
            border: none;
            padding: 5px;
            font-size: 14px;
            background: transparent;
          }

          .data-table .readonly {
            background-color: #f9f9f9;
            color: #666;
            font-style: italic;
            padding: 5px;
          }

          /* Pagina 2 - Stili */
          .title-left {
            text-align: left;
            margin: 0 !important;
            padding-bottom: 10 !important;
          }

          .title-left h2 {
              font-size: 20px;
              color: #333;
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1.5 !important;
            }

          .title-left hr {
              width: 40%;
               margin: 2px 0 2px 0 !important;  /* Spazio minimo */
               padding: 0 !important;
              border: 1px solid #12455b;
            }

          /* Container grafici */
          .charts-container {
              margin: 0 !important;
              padding-bottom: 10 !important;
              height: auto;
              min-height: 0;
              display: flex;
              flex-wrap: wrap;
              gap: 5px;  /* Riduci gap se necessario */
              justify-content: center;  /* centra orizzontalmente */
              align-items: center;
            }

          .chart-item {
            width: calc(50% - 5px);
            height: 350px;
            background: white;
            border: 1px solid #eee;
            border-radius: 4px;
            padding: 5px;
          }

          .chart-item .plot-container {
            width: 100%;
            height: 100%;
          }

          .didascalia {
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1 !important;
              font-size: 11px;
              text-align: center; /* centra il testo */
           }

          .page-number {
              font-size: 8px;
              color: #666;
            }

          @media print {
            .controls {
              display: none;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .page1, .page2 {
              box-shadow: none;
              padding: 0.5cm;
            }
            .chart-item {
              border: none;
              height: 380px;
            }
          }

          /* Titolo principale leggermente più piccolo */
            .h1bis {
              font-size: 18px; /* ridotto rispetto a h1 normale */
              margin-bottom: 0.3em;
              font-weight: bold;
            }

            /* Tabella con font più piccolo */
            .data-table.small-table {
              font-size: 12px;
              border-collapse: collapse;
              width: 100%;
            }

            /* Bordo e padding generale */
            .data-table.small-table th,
            .data-table.small-table td {
              padding: 6px 8px;
              border: 1px solid #ccc;
            }

            /* Riga intestazione grigia solo per i titoli */
            .data-table.small-table thead th {
              background-color: #e0e0e0;
              font-weight: bold;
              text-align: left;
            }

            /* Contenitore tabella centrata e con margine sopra */
            #vsTableContainer {
              display: flex;             /* centro orizzontale */
              justify-content: center;
              margin-top: 40px;          /* spazio sopra la tabella */
              margin-bottom: 20px;
            }

            /* Tabella con font più piccolo e bordi */
            #vsTableContainer table.data-table.small-table {
              font-size: 12px;
              border-collapse: collapse;
              width: auto;               /* larghezza adattata al contenuto */
            }

            /* Bordo e padding generale */
            #vsTableContainer table.data-table.small-table th,
            #vsTableContainer table.data-table.small-table td {
              padding: 6px 8px;
              border: 1px solid #ccc;
              text-align: center;        /* centro il contenuto */
            }

            /* Riga intestazione grigia solo per i titoli */
            #vsTableContainer table.data-table.small-table thead th {
              background-color: #e0e0e0;
              font-weight: bold;
              text-align: center;
            }

            /* Riga alternata opzionale per leggibilità */
            #vsTableContainer table.data-table.small-table tr:nth-child(even) {
              background-color: #f9f9f9;
            }

        </style>
      </head>
      <body>
        <!-- Pulsanti -->
        <div class="controls">
          <button class="print-btn" onclick="window.print()" title="Salva PDF">💾</button>
          <button class="print-btn" onclick="window.close()" title="Chiudi">✖</button>
          <button class="print-btn" onclick="resetEditableFields()" title="Reset Campi">↺</button>
        </div>
        <!-- PAGINA 1 - Verticale -->
        <div class="page1">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>
          <div class="header">
            <h1>V.E.S.</h1>
            <h2>Report indagine sismica MASW</h2>
          </div>
          <table class="data-table">
            <tr><td>Committente</td><td><input type="text" id="committente" value="${committenteVal}"></td></tr>
            <tr><td>Località</td><td><input type="text" id="localita" value="${luogoVal}"></td></tr>
            <tr><td>Via</td><td><input type="text" id="via" value="${indirizzoVal}"></td></tr>
            <tr><td>Nome prova</td><td><input type="text" id="nome" value="${nomeProvaVal}"></td></tr>
            <tr><td>Tipo prova</td><td><div class="readonly">${tipologiaVal}</div></td></tr>
            <tr><td>Data elaborazione</td><td><div class="readonly">${dateStr}</div></td></tr>
          </table>
          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>

        <!-- PAGINA 2 - Orizzontale parametri-->
        <div class="page1">
            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:flex-start; align-items:flex-start; gap:20px; margin-bottom:25px;">
                <!-- Contenuto principale -->
                <div class="content-wrapper" style="display:flex; flex-direction:column; gap:15px;">
                    <div class="title-left">
                        <h2>1 - Indagine sismica ${nomeProvaVal}</h2>
                        <hr>
                    </div>
                    <!-- Legenda -->
                    <div id="lithology-legend"
                         style="display:flex; flex-direction:row; gap:20px; border:1px solid black; padding:10px; margin-bottom:5px; margin-top:5px;">
                        <!-- Colonna Destra: Parametri -->
                        <div id="legend-parameters" style="display:flex; flex-direction:column; gap:5px; padding-left:10px; min-width:150px;">
                            <h1 class="h1bis" style="margin-bottom:5px;">Parametri caratteristici MASW</h1>
                            <div id="Pmax" style="font-family: Roboto, sans-serif; font-size:12px;">Range prof. max (m): ...</div>
                            <div id="vseq" style="font-family: Roboto, sans-serif; font-size:12px;">Vs, eq: ...</div>
                        </div>
                    </div>
                    ${trcLen > 8 ? `
                    <!-- Primo grafico -->
                    <div class="charts-container" id="chartsContainerSeismo" style="margin-bottom:5px;">
                        <!-- I grafici verranno inseriti dinamicamente -->
                    </div>
                    <div class="didascalia">
                        Fig1 - Sismogramma acquisito per l'indagine ${nomeProvaVal}.
                    </div>
                    ` : ''}
                    <!-- Spettro -->
                    <div class="charts-container" style="margin-bottom:5px;">
                        <img id="spettro-image"
                             src="data:image/png;base64,${spettroImg}"
                             alt="Spettro MASW"
                             style="width:520px; height:320px;" />
                    </div>
                    <div class="didascalia">
                        ${trcLen > 8
                            ? `Fig2 - Spettro frequenza-velocità di fase dei dati acquisiti per l'indagine ${nomeProvaVal};<br>
                               sovraimposto allo spettro è il picking del modo fondamentale (linea nera);<br>
                               le linee tratteggiate rappresentano la deviazione standard delle curve utilizzate.`
                            : `Fig1 - Spettro frequenza-velocità di fase dei dati acquisiti per l'indagine ${nomeProvaVal};<br>
                               sovraimposto allo spettro è il picking del modo fondamentale (linea nera);<br>
                               le linee tratteggiate rappresentano la deviazione standard delle curve utilizzate.`}
                    </div>
                </div>
            </div>
        </div>

        <!-- PAGINA 3 - Orizzontale parametri -->
        <div class="page1">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>2 - Modello velocimetrico indagine sismica ${nomeProvaVal}</h2>
              <hr>
            </div>
            <!-- Contenitore flex orizzontale -->
            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:center; align-items:center; gap:20px; margin-bottom:25px;margin-top:30px;">
                <!-- Primo grafico -->
                    <div class="charts-container" id="chartsContainerVs" style="margin-bottom:5px;">
                        <!-- I grafici verranno inseriti dinamicamente -->
                    </div>
                    <!-- Primo grafico -->
                    <div class="charts-container" id="chartsContainerVsFoundation" style="margin-bottom:5px;">
                        <!-- I grafici verranno inseriti dinamicamente -->
                    </div>
            </div>
            <div class="didascalia">
                ${trcLen > 8
                      ? `Fig3 - A sinistra modello Vs-profondità indagine ${nomeProvaVal}; A destra Vs, eq-profondità di posa delle fondazioni indagine ${nomeProvaVal}.`
                      : `Fig2 - A sinistra modello Vs-profondità indagine ${nomeProvaVal}; A destra Vs, eq-profondità di posa delle fondazioni indagine ${nomeProvaVal}.`}
            </div>
            <div id="vsTableContainer"></div>
            <div class="didascalia">
             Tabella 1 - Modello Vs-profondità indagine ${nomeProvaVal}.
        </div>

        <script>
          // Qui va tutto il JS relativo alla pagina
          const pages = document.querySelectorAll('.page1, .page2'); // prende tutte le pagine
          pages.forEach((page, index) => {
            const pageNumberDiv = document.createElement('div');
            pageNumberDiv.className = 'page-number';
            pageNumberDiv.style.position = 'absolute';
            pageNumberDiv.style.bottom = '5px';
            pageNumberDiv.style.left = '10px';
            pageNumberDiv.style.fontSize = '9px';
            pageNumberDiv.style.color = '#666';
            pageNumberDiv.innerText = (index + 1) + " / " + pages.length;
            page.appendChild(pageNumberDiv);
          });
          // Data di stampa
        </script>

        <!-- NESSUN ALTRO DIVISORE - così finisce qui -->

        <script>
           const fpick = ${JSON.stringify(fpick)};
           const spick = ${JSON.stringify(spick)};
           //valori modello
           const parMVVal = ${JSON.stringify(parMVVal)}; // velocità strati
           const parMHVal = ${JSON.stringify(parMHVal)}; // spessori strati
           const tracceVal  = ${JSON.stringify(tracceVal )}; // spessori strati
           const trcLen = Number(${trcLen});
           //valori singoli
           const parVSVal = ${parVSVal};
           const parint = ${parint};
           const parpsubVal = ${parpsubVal};
           const nomeProvaVal = "${nomeProvaVal}";
           const spettroImg = "${spettroImg}";             // Base64 come stringa

           function updateLegendParameters() {
                if (!fpick || fpick.length === 0) return;

                // 1. trova il valore minimo di fpick
                const minFpick = Math.min(...fpick);

                // 2. trova l'indice corrispondente
                const indexMin = fpick.indexOf(minFpick);

                // 3. prendi il valore corrispondente da spick
                const spickVal = spick[indexMin];
                // 4. calcola il range prof. max
                let rangeMax = spickVal / minFpick;   // primo divisione
                const rangeDiv2 = rangeMax / 2;             // diviso 2
                const rangeDiv3 = rangeMax / 3;             // diviso 3

                // 5. aggiorna il DOM
                document.getElementById("Pmax").textContent = "Range prof. max (m): " + rangeDiv3.toFixed(2) +"-" + rangeDiv2.toFixed(2)+" m da p.c. ";

                // Altri parametri
                document.getElementById("vseq").textContent =
                    "Vs, eq: " + parVSVal.toFixed(2) + " m/s";
            }


          const CHART_WIDTH = 550;
          const CHART_HEIGHT = 380;

          const CHARTVS_WIDTH = 400;
          const CHARTVS_HEIGHT = 580;

          window.resetEditableFields = function() {
            document.getElementById('committente').value = '';
            document.getElementById('localita').value = '';
            document.getElementById('via').value = '';
            document.getElementById('nome').value = '';
            localStorage.removeItem('cptReportData');
          };

          function loadSavedData() {
            const saved = localStorage.getItem('cptReportData');
            if (saved) {
              const data = JSON.parse(saved);
              document.getElementById('committente').value = data.committente || '';
              document.getElementById('localita').value = data.localita || '';
              document.getElementById('via').value = data.via || '';
              document.getElementById('nome').value = data.nome || '';
            }
          }

          function saveData() {
            const data = {
              committente: document.getElementById('committente').value,
              localita: document.getElementById('localita').value,
              via: document.getElementById('via').value,
              nome: document.getElementById('nome').value
            };
            localStorage.setItem('cptReportData', JSON.stringify(data));
          }

        function createSeismogramChart() {
            const container = document.getElementById('chartsContainerSeismo');
            if (!container) return;

            container.innerHTML = ''; // pulisce il contenitore
            const chartDiv = document.createElement('div');
            chartDiv.id = 'seismogramChart';
            chartDiv.style.width = (CHART_WIDTH - 20) + 'px';
            chartDiv.style.height = (CHART_HEIGHT - 20) + 'px';
            container.appendChild(chartDiv);
            const nTraces = tracceVal.length;
            if (nTraces === 0) return;
            const Tms = 1000; // ms
            const nSamples = tracceVal[0].length;
            const timeDt = Array.from({ length: nSamples }, (_, i) => i * (Tms / (nSamples - 1)));
            const plotData = [];
            const spacing = parint; // spaziatura tra tracce
            let offset = 0;
            const xTickVals = [];
            const xTickLabels = [];

            let xMin = 0; // per estendere l'asse X
            let xMax = 0;

            tracceVal.forEach((trace, idx) => {
            const maxVal = Math.max(...trace);
            const minVal = Math.min(...trace);
            const aN1 = spacing / (maxVal - minVal); // scala per rientrare nella spaziatura
            const normalizedTrace = trace.map(v => (v - minVal) * aN1 + offset);

            plotData.push({
                x: normalizedTrace,
                y: timeDt,
                mode: 'lines',
                line: { color: 'grey', width: 0.7 },
                type: 'scatter',
                name: ''
            });

            // Tick X posizionato al centro della traccia
            const centerX = (Math.min(...normalizedTrace) + Math.max(...normalizedTrace)) / 2;
            xTickVals.push(centerX);
            xTickLabels.push(offset.toString()); // o un’etichetta più significativa
            // Aggiorno min e max X per l’intero grafico
            xMin = Math.min(xMin, Math.min(...normalizedTrace));
            xMax = Math.max(xMax, Math.max(...normalizedTrace));
            offset += spacing; // incremento offset per la prossima traccia
            });

            const layout = {
                width: CHART_WIDTH - 20,
                height: CHART_HEIGHT - 20,
                margin: { t: 20, r: 40, l: 40, b: 30 }, // spazio a destra per il bordo
                xaxis: {
                    title: { text: 'Offset (m)', font: { family: 'Roboto, sans-serif', size: 10 } },
                    tickvals: xTickVals,
                    ticktext: xTickLabels,
                    tickfont: { family: 'Roboto, sans-serif', size: 9 },
                    range: [xMin - 0.1 * spacing, xMax + 0.1 * spacing],
                    showgrid: false,
                    showline: true,
                    linecolor: 'black',
                    linewidth: 1,
                    mirror: 'allticks',
                    ticks: 'outside'
                },
                yaxis: {
                    title: { text: 'Tempo (ms)', font: { family: 'Roboto, sans-serif', size: 10 } },
                    tickfont: { family: 'Roboto, sans-serif', size: 9 },
                    range: [Tms, 0],
                    autorange: false,
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    showline: false,      // disattivo linea sinistra
                    linecolor: 'black',
                    linewidth: 1,
                    mirror: false,        // disattivo mirror per evitare doppio bordo
                    ticks: 'outside',
                    dtick: 200
                },
                shapes: [
                    // bordo destro asse Y
                    {
                        type: 'line',
                        x0: xMax + 0.1 * spacing,  // posizione bordo destro
                        y0: 0,
                        x1: xMax + 0.1 * spacing,
                        y1: Tms,
                        line: {
                            color: 'black',
                            width: 1
                        },
                        xref: 'x',
                        yref: 'y'
                    }
                ],
                margin: { t: 20, r: 40, l: 60, b: 40 } ,
                showlegend: false
            };
            Plotly.newPlot(chartDiv.id, plotData, layout);
        }

        function createhvLegend(containerId, dict_plt, lineStyles) {
            const container = document.getElementById(containerId);
            if (!container) return;

            container.innerHTML = ''; // pulisce il contenitore

            const labels = Object.keys(dict_plt);

            labels.forEach((label, idx) => {
                const color = dict_plt[label];
                const style = lineStyles[label] || 'solid'; // solid o dash

                // Elemento della legenda
                const item = document.createElement('div');
                item.style.display = 'flex';
                item.style.alignItems = 'center';
                item.style.gap = '5px';
                item.style.fontFamily = 'Roboto, sans-serif';
                item.style.fontSize = '12px';

                // Canvas per il tratto
                const lineCanvas = document.createElement('canvas');
                lineCanvas.width = 40;
                lineCanvas.height = 10;
                const ctx = lineCanvas.getContext('2d');

                ctx.strokeStyle = color;
                ctx.lineWidth = 2;
                if (style === 'dash') {
                    ctx.setLineDash([5, 3]);
                } else {
                    ctx.setLineDash([]);
                }
                ctx.beginPath();
                ctx.moveTo(0, lineCanvas.height / 2);
                ctx.lineTo(lineCanvas.width, lineCanvas.height / 2);
                ctx.stroke();

                // Testo descrittivo
                const text = document.createElement('span');
                text.textContent = label;
                text.style.flex = '1';
                text.style.whiteSpace = 'nowrap';
                text.style.overflow = 'hidden';
                text.style.textOverflow = 'ellipsis';

                item.appendChild(lineCanvas);
                item.appendChild(text);

                container.appendChild(item);
            });
        }

        function createVsProfileChart(mH, mV, containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;

            container.innerHTML = '';

            const chartDiv = document.createElement('div');
            chartDiv.style.width = (CHARTVS_WIDTH - 20) + 'px';
            chartDiv.style.height = (CHARTVS_HEIGHT - 20) + 'px';
            container.appendChild(chartDiv);

            let depth = [0];
            let vsProfile = [mV[0]];

            for (let i = 0; i < mH.length; i++) {
                const top = depth[depth.length - 1];
                const bottom = top + mH[i];

                depth.push(bottom);
                vsProfile.push(mV[i]);

                if (i < mH.length - 1) {
                    vsProfile.push(mV[i + 1]);
                    depth.push(bottom);
                }
            }

            const maxDepth = Math.max(...depth) + 20;
            const maxVs = Math.max(...vsProfile) + 100;

            Plotly.newPlot(chartDiv, [{
                x: vsProfile,
                y: depth,
                type: 'scatter',
                mode: 'lines',
                line: { color: '#31D6C8', width: 2.5 },
                name: nomeProvaVal  +'<br>Vs, eq ' + parVSVal + ' m/s',
                hovertemplate: 'Profondità: %{y} m<br>Vs: %{x} m/s<extra></extra>'
            }], {
                width: CHARTVS_WIDTH - 20,
                height: CHARTVS_HEIGHT - 20,
                xaxis: {
                    title: { text: 'Vs [m/s]', font: { family: 'Roboto, sans-serif', size: 10 } },
                    range: [0, maxVs],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',          // griglia tratteggiata
                    linecolor: 'black',
                    linewidth: 1.2,
                    mirror: true,
                    tickfont: { family: 'Roboto, sans-serif', size: 9 }
                },
                yaxis: {
                    title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 10 } },
                    autorange: false,
                    range: [maxDepth, 0],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',          // griglia tratteggiata
                    linecolor: 'black',
                    linewidth: 1.2,
                    mirror: true,
                    tickfont: { family: 'Roboto, sans-serif', size: 9 }
                },
                margin: { t: 20, r: 20, l: 50, b: 30 },
                showlegend: true
            });
        }
        // Funzione per creare il grafico Vs in funzione della profondità di posa
        function createVsFoundationChart(stratiSpessore, stratiVs, psub, containerId, nomeProvaVal) {
            const container = document.getElementById(containerId);
            if (!container) return;
            container.innerHTML = '';
            const chartDiv = document.createElement('div');
            chartDiv.style.width = (CHARTVS_WIDTH - 20) + 'px';
            chartDiv.style.height = (CHARTVS_HEIGHT - 20) + 'px';
            container.appendChild(chartDiv);

            const depthArray = []; // profondità 0-10 m
            const vsSeqT = [];     // Vs equivalente

            // Loop profondità di posa da 0 a 10 m
            for (let nh = 0; nh <= 10; nh++) {
                depthArray.push(nh);

                // Copia degli strati
                let Htemp = [...stratiSpessore];
                let Vtemp = [...stratiVs];

                // Riduzione dello strato in cima di nh metri
                let remaining = nh;
                while (remaining > 0 && Htemp.length > 0) {
                    if (Htemp[0] <= remaining) {
                        remaining -= Htemp[0];
                        Htemp.shift();
                        Vtemp.shift();
                    } else {
                        Htemp[0] -= remaining;
                        remaining = 0;
                    }
                }

                // Calcolo somma pesata
                let sumHdivV = 0;
                let profAccum = 0;
                for (let i = 0; i < Htemp.length; i++) {
                    if (profAccum + Htemp[i] <= psub) {
                        sumHdivV += Htemp[i] / Vtemp[i];
                        profAccum += Htemp[i];
                    } else {
                        let lastH = psub - profAccum;
                        sumHdivV += lastH / Vtemp[i];
                        profAccum = psub;
                        break;
                    }
                }

                // Vs equivalente
                const vsEq = psub / sumHdivV;
                vsSeqT.push(vsEq);
            }

            // Plotly
            const trace = [{
                x: vsSeqT,
                y: depthArray,
                type: 'scatter',
                mode: 'lines+markers',
                line: { color: '#86B8B4', width: 2, dash:'dash' },
                marker: { size: 10, color: '#31D6C8', symbol: 'cross',line: {color: 'black',width: 1} },
                name: nomeProvaVal  +'<br>Vs, eq = f(h)',
                hovertemplate: 'Profondità: %{y} m<br>Vs: %{x} m/s<extra></extra>'
            }];

            const maxVs = Math.max(...vsSeqT) + 200;

            Plotly.newPlot(chartDiv, trace, {
                width: CHARTVS_WIDTH - 20,
                height: CHARTVS_HEIGHT - 20,
                xaxis: {
                    title: { text: 'Vs, eq [m/s]', font: { family: 'Roboto, sans-serif', size: 10 } },
                    range: [0, maxVs],
                    dtick: 100,
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    linecolor: 'black',
                    linewidth: 1.2,
                    mirror: true,
                    tickfont: { family: 'Roboto, sans-serif', size: 9 }
                },
                yaxis: {
                    title: { text: 'Prof. piano posa fondazioni [m]', font: { family: 'Roboto, sans-serif', size: 10 } },
                    autorange: false,
                    range: [Math.max(...depthArray), 0],
                    showgrid: true,
                    gridcolor: '#888888',
                    griddash: 'dash',
                    linecolor: 'black',
                    linewidth: 1.2,
                    mirror: true,
                    tickfont: { family: 'Roboto, sans-serif', size: 9 }
                },

                shapes: [
                    {
                        type: 'line',
                        x0: 180, x1: 180,
                        y0: 0, y1: 1,
                        xref: 'x',
                        yref: 'paper',
                        line: { color: '#080808', width: 2, dash: 'dashdot' }
                    },
                    {
                        type: 'line',
                        x0: 360, x1: 360,
                        y0: 0, y1: 1,
                        xref: 'x',
                        yref: 'paper',
                        line: { color: '#080808', width: 2, dash: 'dashdot' }
                    },
                    {
                        type: 'line',
                        x0: 800, x1: 800,
                        y0: 0, y1: 1,
                        xref: 'x',
                        yref: 'paper',
                        line: { color: '#080808', width: 2, dash: 'dashdot' }
                    }
                ],

                margin: { t: 20, r: 20, l: 50, b: 30 },
                showlegend: true
            });
        }

        function createVsTable(mH, mV, nomeProvaVal, containerId) {

            const container = document.getElementById(containerId);
            if (!container) return;

            container.innerHTML = '';

            const table = document.createElement('table');
            table.style.borderCollapse = 'collapse';
            table.style.fontFamily = 'Roboto, sans-serif';
            table.style.fontSize = '11px';

            // Header
            const header = document.createElement('tr');
            const headers = ['Nome prova', 'Strato' ,'Tetto [m]', 'Letto [m]', 'Vs [m/s]'];
            headers.forEach(text => {
                const th = document.createElement('th');
                th.innerText = text;
                th.style.border = '1px solid #aaa';
                th.style.padding = '4px';
                th.style.background = '#eeeeee';
                header.appendChild(th);
            });
            table.appendChild(header);

            let depthTop = 0;

            for (let i = 0; i < mH.length; i++) {
                const depthBottom = depthTop + mH[i];
                const row = document.createElement('tr');

                const values = [
                    i === 0 ? nomeProvaVal : '',  // solo nella prima riga
                    i + 1,
                    depthTop.toFixed(2),
                    depthBottom.toFixed(2),
                    mV[i]
                ];
                values.forEach(val => {
                    const td = document.createElement('td');
                    td.innerText = val;
                    td.style.border = '1px solid #aaa';
                    td.style.padding = '4px';
                    td.style.textAlign = 'center';
                    row.appendChild(td);
                });
                table.appendChild(row);
                depthTop = depthBottom;
            }
            container.appendChild(table);
        }

          // Inizializzazione
          loadSavedData();
          createSeismogramChart();
          createVsProfileChart(parMHVal, parMVVal, 'chartsContainerVs');
          // Creazione grafico Vs_eq vs profondità di posa
          createVsFoundationChart(parMHVal, parMVVal, parpsubVal, 'chartsContainerVsFoundation', nomeProvaVal);
          updateLegendParameters();
          createVsTable(parMHVal, parMVVal, nomeProvaVal, 'vsTableContainer');


          document.getElementById('committente').addEventListener('input', saveData);
          document.getElementById('localita').addEventListener('input', saveData);
          document.getElementById('via').addEventListener('input', saveData);
          document.getElementById('nome').addEventListener('input', saveData);

        </script>
      </body>
    </html>
  `);

  reportWindow.document.close();
};